const dataMutiEn = [
  {
    id: 7,
    url: 'ims-00241',
    image: require('../../../../../assets/iso/IMS-00241.jpg'),
    title: 'SUCOFINDO INTERNATIONAL CERTIFICATION SERVICE',
    description: 'PT. REMALA ABADI Tbk - has implemented an integrated management system',
    scope:
      'Internet Service Provisioning that includes Broadband Internet Service (Internet Service Provider/ISP), Local Link Service, Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, as well as Provisioning of Connectivity/Installation of Business to Business Fiber Optics',
  },
  {
    id: 4,
    url: 'iso-9001',
    image: require('../../../../../assets/iso/QSC-02073.jpg'),
    title: 'SNI ISO 9001:2015',
    description: 'Quality Management System - Requirements.',
    scope:
      'Environmental Aspect and Impact Control in Internet Service Provisioning Services covering Broadband Internet services (Internet Service Provider/ISP), Local Link Services, Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, as well as Business-to-Business Fiber Optic Connectivity/Installation Provisioning.',
  },
  {
    id: 5,
    url: 'iso-37001',
    image: require('../../../../../assets/iso/SAB-00147.jpg'),
    title: 'SNI ISO 37001:2016',
    description: 'Anti-Bribery Management System.',
    scope: 'Implementation of anti-corruption management system in HRGA & Legal Division, Purchasing, Finance Accounting Tax',
  },
  {
    id: 2,
    url: 'iso-27001',
    image: require('../../../../../assets/iso/ISMS-00025.jpg'),
    title: 'SNI ISO/IEC 27001:2022',
    description: 'Information Security Management System Requirements.',
    scope:
      'Environmental Aspect and Impact Control in Internet Service Provisioning Services covering Broadband Internet services (Internet Service Provider/ISP), Local Link Services, Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, as well as Business-to-Business Fiber Optic Connectivity/Installation Provisioning.',
  },
  {
    id: 3,
    url: 'iso-45001',
    image: require('../../../../../assets/iso/OHS-00252.jpg'),
    title: 'SNI ISO 45001:2018',
    description: 'Occupational Health and Safety Management System - Requirements with guidance for use.',
    scope:
      'Environmental Aspect and Impact Control in Internet Service Provisioning Services covering Broadband Internet services (Internet Service Provider/ISP), Local Link Services, Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, as well as Business-to-Business Fiber Optic Connectivity/Installation Provisioning.',
  },
  {
    id: 1,
    url: 'iso-14001',
    image: require('../../../../../assets/iso/EMS-00452.jpg'),
    title: 'SNI ISO 14001:2015',
    description: 'Environmental Management System - Requirements with guidance for use.',
    scope:
      'Environmental Aspect and Impact Control in Internet Service Provisioning Services covering Broadband Internet services (Internet Service Provider/ISP), Local Link Services, Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, as well as Business-to-Business Fiber Optic Connectivity/Installation Provisioning.',
  },
  {
    id: 6,
    url: 'iso-20000-1',
    image: require('../../../../../assets/iso/ISO20000-1-ACS-2026.jpeg'),
    title: 'SNI ISO 20000-1:2018',
    description: 'Internet Service Provider Servicing for Internet Dedicated.',
    scope: 'Internet Service Provider Servicing dor Internet Dedicated, Internet Broadband & Manage Service for Wi-Fi Device, LAN, Application Software and IT Service Management',
  },
];

export default dataMutiEn;
